module.exports = __webpack_public_path__ + "static/img_0349-803168825314596bc96860d0424dfa88.webp";